
import { defineComponent, getCurrentInstance, ref } from "vue";
import lang, { Language } from "./languages";
import { useStore } from "@whitekite/vue-helper";
import { Vue } from "vue/types/vue";

export default defineComponent({
  name: "LanguageDropdown",
  setup: (_props) => {
    const { proxy: root } = getCurrentInstance() as { proxy: Vue };
    const languages = ref<Language[]>(lang);

    const store = useStore<any>();

    const defineDropdownOrder = () => {
      const defaultLang = store.state.language;
      const index = languages.value.findIndex(
        (item) => item.label === defaultLang
      );
      if (index > 0) {
        // 将选的的语言置换到数组最前
        const [lang] = languages.value.splice(index, 1);
        languages.value.splice(0, 0, lang);
      }
    };

    const handleDropClick = (lang: Language) => {
      if (lang.isOpen) {
        store.commit("setLanguage", lang.label);
        root.$i18n.locale = lang.label;
        root.$router.go(0);
      }
    };

    defineDropdownOrder();

    return {
      languages,
      handleDropClick,
    };
  },
});
